import { api } from '@/shared/api/client';

/**
 * `POST /api/auth/logout` from the idle-session hook — slice-4919 (Q195, John 3 Nov, Option 1).
 *
 * <p>The SAME endpoint Sign Out calls (`features/auth/login/api.ts` `logout`), so the server ends
 * the session, frees the license slot and stamps the User Login Log logout time exactly as Sign
 * Out does (PB writes it on normal app close, `f_phfc_app_close.srf`). Before this the idle
 * timeout only cleared the browser and the row kept a blank logout time.
 *
 * <p>Fire-and-forget: the token is read synchronously when `api()` is called, so the caller can
 * clear the local session straight after. Any failure (server down, token already dead) is
 * swallowed — the local sign-out happens regardless, and the server's own idle cleanup stamps
 * the row later. `keepSessionOn401` so a 401 here cannot re-clear the store and wipe the reason
 * the login page is about to show.
 */
export function endSessionOnServer(): void {
  try {
    void api<void>('/api/auth/logout', { method: 'POST', keepSessionOn401: true }).catch(() => {
      /* best effort — see above */
    });
  } catch {
    /* best effort — see above */
  }
}
